import { render, staticRenderFns } from "./DisplayControlPanel.vue?vue&type=template&id=80c5b5ca&scoped=true"
import script from "./DisplayControlPanel.vue?vue&type=script&lang=js"
export * from "./DisplayControlPanel.vue?vue&type=script&lang=js"
import style0 from "./DisplayControlPanel.vue?vue&type=style&index=0&id=80c5b5ca&prod&scoped=true&lang=css"
import style1 from "./DisplayControlPanel.vue?vue&type=style&index=1&id=80c5b5ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c5b5ca",
  null
  
)

export default component.exports